import { createAPI } from '@common'
import { get } from 'sortablejs'
export default {

  //获取专题分组/专题列表
  getSpecialList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjd0mjtu', 'GET', config),
  //专题分组、专题新增、修改
  postSpecialSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjd0tbwf', 'POST', config),
  //专题分组、专题删除
  postSpecialDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjd0efmfuf', 'POST', config),
  //专题分组、专题排序
  postSpecialSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjd0tpsu', 'POST', config),
  //专题稿件-列表查询
  getSpecialTopicArticleList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjdBsujdmf0mjtu', 'get', config, vconfig),
  // 获取根文件夹
  getFolderRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0benjo', 'GET', config),
  // 获取子文件夹
  getAdminFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60benjo0epn0gpmefst', 'GET', config),
  // 根据docLibID获取其根文件夹ID
  getFoldersAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0benjo', 'GET', config),
  getFoldersTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0usff', 'GET', config),
  //获取云媒资列表
  postAssetList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bttfu0mjtu', 'POST', config),
  //稿件追加
  postSpeicialAdd: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjdBsujdmf0bee', 'POST', config),
  //定制条件
  postConditionSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjd0dpoejujpo0tbwf', 'POST', config),
  //预览云媒资的详情
  getAssetsDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bttfu0hfuCzJE', 'GET', config),
  //稿件移除
  postSpecialRemove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjdBsujdmf0efmfuf', 'POST', config),
  //稿件选用
  postSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjdBsujdmf0tfmfdu', 'POST', config),


}
